<template>
	<view class="store">
		<!-- 轮播图 -->
		<view class="store_banner">
			<uni-swiper-dot :info="info" :current="current" field="content" mode="round">
				<swiper class="swiper-box" @change="change">
					<swiper-item v-for="(item, index) in 3" :key="index">
						<view class="swiper-item">
							<image src="@/static/images/Maskgroup@2x.png" mode="aspectFill"></image>
						</view>
					</swiper-item>
				</swiper>
			</uni-swiper-dot>
			<view class="store_banner_mode">
				<text>{{current}}/{{info.length}}</text>
			</view>
		</view>
		<!-- 活动信息 -->
		<view class="store_info">
			<view class="title">麦隆咖啡</view>
			<view class="list">
				<view class="list_item">
					<image src="@/static/icon/huodong_ic_time@2x.png" mode="widthFix"></image>
					<text>2022-12-26 00:00～2022-12-26 23:59</text>
				</view>
				<view class="list_item">
					<image src="@/static/icon/huodong_ic_didian@2x.png" mode="widthFix"></image>
					<text>上海市闵行区申长路虹桥天地南区688号G层中岛gf36</text>
				</view>
				<view class="list_item">
					<image src="@/static/icon/huodong_ic_renshu@2x.png" mode="widthFix"></image>
					<text>已报名人数36/100</text>
				</view>
			</view>
			<view class="store">
				<StoreInformation :info="data" />
			</view>
		</view>
		<!-- 活动详情 -->
		<view class="store_story">
			<view class="title">活动详情</view>
			<view class="content">
				弗洛里安咖啡馆(Coffee Florian)位于意大利佛罗伦萨威尼斯圣马可广场1720年开业，是意大利历史上最早的咖啡馆，至今仍在营业，狄更斯、歌德、拜伦等都曾曾曾在营业，狄更斯、歌德、拜伦等都曾曾曾
			</view>
		</view>
		<!-- 操作 -->
		<view class="shop_operate">
			<view class="shop_operate_list">
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_shoucang@2x.png" mode="widthFix"></image>
					<text>收藏</text>
				</view>
				<view class="shop_operate_list_item">
					<image src="@/static/icon/ic_fenxiang@2x.png" mode="widthFix"></image>
					<text>分享</text>
				</view>
			</view>
			<view class="shop_operate_ipt bgf" @click="toggle">立即报名</view>
		</view>
		<!-- 报名弹框 -->
		<uni-popup ref="popup" background-color="#fff">
			<view class="popup">
				<view class="popup_title">活动报名</view>
				<view class="popup_list">
					<view class="popup_list_item">
						<view class="popup_list_item_label">
							<text class="label">真实姓名</text>
							<text class="required">*</text>
						</view>
						<input type="text" />
					</view>
					<view class="popup_list_item">
						<view class="popup_list_item_label">
							<text class="label">手机号</text>
							<text class="required">*</text>
						</view>
						<input type="text" />
					</view>
					<view class="popup_list_item">
						<view class="popup_list_item_label">
							<text class="label">手机号</text>
							<text class="required">*</text>
						</view>
						<input type="text" />
						<view class="popup_list_item_submit">
							获取验证码
						</view>
					</view>
					<view class="popup_list_item">
						<view class="popup_list_item_label">
							<text class="label">企业名称</text>
							<text class="info">（选填）</text>
						</view>
						<input type="text" />
					</view>
				</view>
				<view class="popup_submit" @click="toggle1">立即报名</view>
			</view>
		</uni-popup>
		<!-- 报名成功弹框 -->
		<uni-popup ref="success" background-color="#fff">
			<view class="popup">
				<view class="popup_icon">
					<image src="@/static/icon/ic_success@2x.png" mode="widthFix"></image>
				</view>
				<view class="popup_info">
					<text>恭喜报名成功</text>
					<text>尽请期待，即将开启精彩时刻</text>
				</view>
				<view class="popup_submit1" @click="close">我知道了</view>
			</view>
		</uni-popup>
	</view>
</template>

<script>
	import StoreInformation from '@/components/StoreInformation/index.vue'
	export default {
		data() {
			return {
				current: 1,
				info: [{
					content: '内容 A'
				}, {
					content: '内容 B'
				}, {
					content: '内容 C'
				}],
				data: {
					img: require('@/static/images/home_banner.png'),
					name: '测试商家',
					divide: 5,
					address: '上海市闵行区申虹路'
				}
			}
		},
		components: { StoreInformation },
		methods: {
			change(e) {
				this.current = e.detail.current + 1;
			},
			toggle() {
				this.$refs.popup.open('center')
			},
			toggle1() {
				this.$refs.popup.close()
				this.$refs.success.open('center')
			},
			close() {
				this.$refs.success.close()
			}
		}
	}
</script>

<style>
	page {
		background-color: #F5F5F5 !important;
	}
	.uni-popup__wrapper {
		border-radius: 32rpx !important;
	}
</style>

<style lang="scss" scoped>
	.store {
		width: 100%;
		.store_banner /deep/ {
			width: 100%;
			height: 748rpx;
			position: relative;
			.store_banner_mode {
				position: absolute;
				bottom: 42rpx;
				right: 32rpx;
				width: 64rpx;
				height: 36rpx;
				background: rgba(0,0,0,0.4);
				border-radius: 18rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				text {
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
			.uni-swiper__warp {
				width: 100%;
				height: 100%;
			}
			.uni-swiper__dots-box {
				display: none;
			}
			.swiper-box {
				width: 100%;
				height: 100%;
				.swiper-item {
					width: 100%;
					height: 100%;
					image {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
		.store_info {
			width: 100%;
			background-color: #FFFFFF;
			padding: 28rpx 32rpx;
			box-sizing: border-box;
			.title {
				font-size: 36rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.store {
				width: 100%;
				margin-top: 30rpx;
			}
			.list {
				width: 100%;
				display: flex;
				flex-direction: column;
				.list_item {
					display: flex;
					align-items: center;
					margin-top: 20rpx;
					image {
						width: 24rpx;
						height: 24rpx;
						margin-right: 10rpx;
						flex-shrink: 0;
					}
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #333333;
					}
				}
			}
		}
		.store_story {
			width: 100%;
			margin-top: 16rpx;
			padding: 28rpx 30rpx;
			box-sizing: border-box;
			background-color: #FFFFFF;
			.title {
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
				margin-bottom: 20rpx;
			}
			.content {}
		}
		.shop_operate {
			width: 100%;
			padding: 16rpx 32rpx calc(env(safe-area-inset-bottom) + 16rpx) 0;
			box-sizing: border-box;
			background-color: #FFFFFF;
			border: 2rpx solid #F4F5F4;
			position: sticky;
			bottom: 0;
			left: 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.bgf {
				background: #D9D9D9 !important;
			}
			.shop_operate_ipt {
				width: 522rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 32rpx 32rpx 32rpx 32rpx;
				box-sizing: border-box;
				font-size: 32rpx;
				font-family: PingFang SC-Regular, PingFang SC;
				font-weight: 400;
				color: #FFFFFF;
				margin-left: 20rpx;
			}
			.shop_operate_list {
				flex: 1;
				display: flex;
				align-items: center;
				.shop_operate_list_item {
					flex: 1;
					display: flex;
					align-items: center;
					flex-direction: column;
					image {
						width: 30rpx !important;
						height: 30rpx !important;
						margin-bottom: 8rpx;
					}
					text {
						font-size: 16rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
		}
		.popup {
			width: 554rpx;
			padding: 42rpx 32rpx;
			border-radius: 32rpx;
			box-sizing: border-box;
			.popup_icon {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				image {
					width: 136rpx;
					height: 138rpx;
				}
			}
			.popup_info {
				width: 100%;
				margin-top: 46rpx;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				text {
					&:first-child {
						font-size: 32rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #333333;
					}
					&:last-child {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						margin-top: 32rpx;
					}
				}
			}
			.popup_title {
				width: 100%;
				text-align: center;
				font-size: 32rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #333333;
			}
			.popup_list {
				width: 100%;
				margin-top: 50rpx;
				.popup_list_item {
					width: 100%;
					height: 96rpx;
					display: flex;
					align-items: center;
					border-bottom: 2rpx solid #F4F5F4;
					.popup_list_item_label {
						flex-shrink: 0;
						display: flex;
						align-items: center;
						margin-right: 20rpx;
						.label {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.required {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #ff0000;
						}
						.info {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #999999;
						}
					}
					.input {
						flex: 1;
						height: 100%;
						font-size: 32rpx;
					}
					.popup_list_item_submit {
						flex-shrink: 0;
						width: 172rpx;
						height: 56rpx;
						text-align: center;
						line-height: 56rpx;
						background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
						border-radius: 28rpx;
						font-size: 28rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
						margin-left: 20rpx;
					}
				}
			}
			.popup_submit1 {
				width: 100%;
				margin-top: 80rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 56rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
			}
			.popup_submit {
				width: 100%;
				margin-top: 64rpx;
				height: 64rpx;
				line-height: 64rpx;
				text-align: center;
				background: linear-gradient(90deg, #D95A5A 0%, #D20A0A 100%);
				border-radius: 56rpx;
				font-size: 28rpx;
				font-family: PingFang SC-Semibold, PingFang SC;
				font-weight: 600;
				color: #FFFFFF;
			}
		}
	}
</style>